import { takeLatest } from 'redux-saga/effects';
import * as types from './reducer';
import {loginSaga, logoutSaga} from "./handler";

export default function* watchUserAuthentication() {
    yield takeLatest(types.LOGIN_USER, loginSaga);
    yield takeLatest(types.LOGOUT_USER, logoutSaga);
}
